import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=dc710380&scoped=true&"
import script from "./FileSelector.vue?vue&type=script&lang=js&"
export * from "./FileSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=dc710380&prod&lang=css&"
import style1 from "./FileSelector.vue?vue&type=style&index=1&id=dc710380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc710380",
  null
  
)

export default component.exports